import { render, staticRenderFns } from "./Clauseliability.vue?vue&type=template&id=4d5264dc&scoped=true&"
import script from "./Clauseliability.vue?vue&type=script&lang=js&"
export * from "./Clauseliability.vue?vue&type=script&lang=js&"
import style0 from "./Clauseliability.vue?vue&type=style&index=0&id=4d5264dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5264dc",
  null
  
)

export default component.exports